import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class User extends BaseAdapter {
  namespace = 'auth/v4';
  modelNamePlural = 'users';
}
